import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects/index';
import { Action } from '@ngrx/store/index';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store/index';

import { ProductCategoriesState } from './product-categories.store';
import { ProductCategoriesActions } from './product-categories.actions';
import { ProductCategoriesService } from './product-categories.service';
import { ProductCategory } from './product-category';
import { LoggingService } from '../loging/logging.service';
export class ProductCategoriesEffects {
private localFile: any;
/**
 * @param {?} actions
 * @param {?} productCategoriesActions
 * @param {?} productCategoriesService
 * @param {?} store
 * @param {?} loggingService
 */
constructor(
private actions: Actions,
private productCategoriesActions: ProductCategoriesActions,
private productCategoriesService: ProductCategoriesService,
private store: Store<ProductCategoriesState>,
private loggingService: LoggingService
    ) {

    }

    @Effect() loadProductCategories =
    this.actions.ofType(ProductCategoriesActions.LOAD_PRODUCT_CATEGORIES)
        .switchMap(() => this.productCategoriesService.getProductCategories())
        .map(productCategories => this.productCategoriesActions.loadProductCategoriesSuccess(productCategories));

    @Effect() addProductCategory =
    this.actions.ofType(ProductCategoriesActions.ADD_PRODUCT_CATEGORY)
        .map((action: Action) => action.payload)
        .switchMap((productCategory: ProductCategory) => this.productCategoriesService.addProductCategory(productCategory))
        .do(res => this.loggingService.log(res))
        .map((productCategory: ProductCategory) => this.productCategoriesActions.addProductCategorySuccess(productCategory));

    @Effect() deleteProductCategory =
    this.actions.ofType(ProductCategoriesActions.DELETE_PRODUCT_CATEGORY)
        .map((action: Action) => action.payload)
        .switchMap((productCategoryName: string) => this.productCategoriesService.deleteProductCategory(productCategoryName))
        .map((res) => this.productCategoriesActions.deleteProductCategorySuccess(res));

    @Effect() moveProductCategoryTo =
    this.actions.ofType(ProductCategoriesActions.MOVE_PRODUCT_CATEGORY_TO)
        .map((action: Action) => action.payload)
        .switchMap((payload: { productCategoryName: string, displayIndex: number }) => this.productCategoriesService.moveProductCategoryTo(payload.productCategoryName, payload.displayIndex))
        .map((res) => this.productCategoriesActions.moveProductCategoryToSuccess(res));

    @Effect() getProductCategoryImageSignature =
    this.actions.ofType(ProductCategoriesActions.GET_PRODUCT_CATEGORY_IMAGE_SIGNATURE)
        .map((action: Action) => action.payload)
        // .do((payload:any) => {
        //     this.loggingService.log('getProductCategoryImageSignature: payload = ');
        //     this.loggingService.log(payload);
        // })
        .switchMap((payload: { ProductCategory: ProductCategory, File: any, FileName: string }) => this.productCategoriesService.getImageSignature(payload.ProductCategory, payload.FileName, payload.File.type, payload.File))
        // .do((payload: { response: any, File: any, ProductCategory: ProductCategory }) => {
        //     this.loggingService.log("after getImageSignature:payload = ");
        //     this.loggingService.log(payload);
        // })
        .map((payload: { response: any, File: any, ProductCategory: ProductCategory }) => this.productCategoriesActions.getProductCategoryImageSignatureSuccess(payload));

    @Effect() getProductCategoryImageSignatureSuccess =
    this.actions.ofType(ProductCategoriesActions.GET_PRODUCT_CATEGORY_IMAGE_SIGNATURE_SUCCESS)
        .map((action: Action) => action.payload)
        // .do((payload:any) => {
        //     this.loggingService.log('getProductCategoryImageSignatureSuccess: payload = ');
        //     this.loggingService.log(payload);
        // })
        .switchMap((payload: { response: any, File: any, ProductCategory: ProductCategory }) => this.productCategoriesService.uploadImage(payload.File, payload.response.signed_request, payload.response.url, payload.ProductCategory))
        // .do((payload:any)=> {
        //     this.loggingService.log('getProductCategoryImageSignatureSuccess: loadImage: payload = ');
        //     this.loggingService.log(payload);
        // })
        .map((payload: {ImageUrl: string, ProductCategory: ProductCategory}) => {
            return this.productCategoriesActions.updateProductCategoryImage(payload.ProductCategory, payload.ImageUrl);
            // this.store.dispatch(this.productCategoriesActions.loadProductCategories());
        });
    
        @Effect() updateProductCategoryImage =
        this.actions.ofType(ProductCategoriesActions.UPDATE_PRODUCT_CATEGORY_IMAGE)
            .map((action: Action) => action.payload)
            .do((payload: any) => {
                this.loggingService.log("updateProductCategoryImage:payload = ");
                this.loggingService.log(payload);
            })
            .switchMap((payload: { ProductCategory: ProductCategory, ImageUrl: string }) => this.productCategoriesService.updateProductCategoryImageUrl(payload.ProductCategory, payload.ImageUrl))
            .do((payload: any) => {
                this.loggingService.log("payload = ");
                this.loggingService.log(payload);
            });
            // .map((payload: { response: any, File: any }) => this.store.dispatch(this.productCategoriesActions.getProductCategoryImageSignatureSuccess(payload)));

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Actions, },
{type: ProductCategoriesActions, },
{type: ProductCategoriesService, },
{type: Store, },
{type: LoggingService, },
];
}

function ProductCategoriesEffects_tsickle_Closure_declarations() {
/** @type {?} */
ProductCategoriesEffects.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProductCategoriesEffects.ctorParameters;
/** @type {?} */
ProductCategoriesEffects.prototype.localFile;
/** @type {?} */
ProductCategoriesEffects.prototype.loadProductCategories;
/** @type {?} */
ProductCategoriesEffects.prototype.addProductCategory;
/** @type {?} */
ProductCategoriesEffects.prototype.deleteProductCategory;
/** @type {?} */
ProductCategoriesEffects.prototype.moveProductCategoryTo;
/** @type {?} */
ProductCategoriesEffects.prototype.getProductCategoryImageSignature;
/** @type {?} */
ProductCategoriesEffects.prototype.getProductCategoryImageSignatureSuccess;
/** @type {?} */
ProductCategoriesEffects.prototype.updateProductCategoryImage;
/** @type {?} */
ProductCategoriesEffects.prototype.actions;
/** @type {?} */
ProductCategoriesEffects.prototype.productCategoriesActions;
/** @type {?} */
ProductCategoriesEffects.prototype.productCategoriesService;
/** @type {?} */
ProductCategoriesEffects.prototype.store;
/** @type {?} */
ProductCategoriesEffects.prototype.loggingService;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
